import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, checking } = useAuth();
  const loc = useLocation();

  if (checking || user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#E61A27] border-t-transparent" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return (
      <div className="mx-auto max-w-xl px-6 py-24 text-center" data-testid="forbidden">
        <h2 className="font-display text-3xl text-slate-900">Restricted</h2>
        <p className="mt-3 text-slate-500">
          Your role (<span className="text-[#D4AF37] capitalize">{user.role}</span>) cannot access this workspace.
        </p>
      </div>
    );
  }
  return children;
}
